import { Chip } from "@mui/material";
import SvgIconStyle from "./SvgIconStyle";

const PercentageChip = ({ value }: { value: number }) => {
  const color = value > 0 ? "success" : "error";
  const image =
    value > 0
      ? "/assets/icons/general/upArrow.svg"
      : "/assets/icons/general/downArrow.svg";

  return (
    <Chip
      label={`${value}%`}
      color={color}
      icon={<SvgIconStyle src={image} sx={{ width: 12, height: 12, ml: 1 }} />}
    />
  );
};

export default PercentageChip;
